// src/stores/feedStore.js
import { defineStore } from "pinia";
import api from "@/services/api";

const FEED_URL = "/portal/feed";
// api base is typically .../api/v1 — full path: /api/v1/portal/feed

export const useFeedStore = defineStore("feed", {
  state: () => ({
    loading: false,
    loaded: false,
    error: null,

    activities: [],
    consultationTypes: [],
    consultationStatuses: [],
  }),

  actions: {
    async fetchFeedOnce() {
      if (this.loaded || this.loading) return;

      this.loading = true;
      this.error = null;

      try {
        const { data } = await api.get(FEED_URL, {
          headers: { Accept: "application/json" },
        });

        const payload = data?.data || data || {};

        this.activities = payload.activities || [];
        this.consultationTypes = payload.consultations_types || [];
        this.consultationStatuses = payload.consultations_statuses || [];

        this.loaded = true;
      } catch (e) {
        this.error = e;
        this.activities = [];
        this.consultationTypes = [];
        this.consultationStatuses = [];
      } finally {
        this.loading = false;
      }
    },

    // لو تحب تعيد تحميل البيانات (مثلا بعد logout/login)
    reset() {
      this.loading = false;
      this.loaded = false;
      this.error = null;
      this.activities = [];
      this.consultationTypes = [];
      this.consultationStatuses = [];
    },
  },
});
